import type { PrimitiveAtom } from 'jotai';
import { atom } from 'jotai';

import type { ProfileType } from '@/components/pages/giveaway-picker/Types/types';

export const socialProfileAtom = atom(null) as PrimitiveAtom<ProfileType>;
